var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "big_box",
      staticStyle: {
        width: "100%",
        overflow: "auto",
        height: "calc(100vh - 64px - 48px)",
        position: "relative",
      },
    },
    [
      !_vm.open
        ? _c("a-spin", { staticClass: "a_spin", attrs: { size: "large" } })
        : _c(
            "div",
            [
              _c(
                "div",
                { staticClass: "search_big_box fix" },
                [
                  _c("a-cascader", {
                    ref: "cascaderAddr",
                    staticClass: "cas_area",
                    staticStyle: { width: "12%", "margin-right": "18px" },
                    attrs: {
                      placeholder: "请选择所在区域",
                      options: _vm.treeData,
                      fieldNames: {
                        label: "name",
                        value: "code_id",
                        children: "children",
                      },
                      "change-on-select": "",
                    },
                    on: {
                      change: _vm.cascaderChange,
                      popupVisibleChange: _vm.popupVisibleChange,
                    },
                    model: {
                      value: _vm.treeData2,
                      callback: function ($$v) {
                        _vm.treeData2 = $$v
                      },
                      expression: "treeData2",
                    },
                  }),
                  _c("a-cascader", {
                    ref: "cascader",
                    staticClass: "select_box",
                    staticStyle: { width: "20%" },
                    attrs: {
                      "field-names": {
                        label: "name",
                        value: "code",
                        children: "children",
                      },
                      "change-on-select": "",
                      options: _vm.newlist,
                      placeholder: "请选择行业",
                    },
                    on: { change: _vm.onChangeCascader },
                  }),
                  _c("a-input", {
                    staticClass: "select_box",
                    attrs: { placeholder: "关键字搜索" },
                    model: {
                      value: _vm.keyWord,
                      callback: function ($$v) {
                        _vm.keyWord = $$v
                      },
                      expression: "keyWord",
                    },
                  }),
                  _c(
                    "a-button",
                    { staticClass: "search_box", on: { click: _vm.dataForm } },
                    [_vm._v(" 搜索 ")]
                  ),
                  _c("a-button", { on: { click: _vm.getData } }, [
                    _vm._v(" 重置 "),
                  ]),
                ],
                1
              ),
              _c("div", { staticClass: "img_data fix" }, [
                _c("div", {
                  ref: "map",
                  staticClass: "img_box l",
                  attrs: { id: "container" },
                }),
                _vm.closeData
                  ? _c("div", { staticClass: "data_box r" }, [
                      _c("div", { staticClass: "location_box" }, [
                        _c(
                          "div",
                          { staticClass: "location_left_box l" },
                          [
                            _c("div", { staticClass: "location_img l" }, [
                              _c("img", {
                                attrs: {
                                  src: require("@/assets/img/location_logo.png"),
                                  alt: "",
                                },
                              }),
                            ]),
                            _c(
                              "a-tooltip",
                              { staticClass: "current_area l" },
                              [
                                _c("template", { slot: "title" }, [
                                  _vm._v(" " + _vm._s(_vm.yourRegion) + " "),
                                ]),
                                _vm._v(
                                  " 当前区域：" + _vm._s(_vm.yourRegion) + " "
                                ),
                              ],
                              2
                            ),
                          ],
                          1
                        ),
                        _c("div", { staticClass: "location_right_box r fix" }, [
                          _c(
                            "div",
                            {
                              staticClass: "r",
                              staticStyle: { "margin-left": "5px" },
                            },
                            [
                              _c("a-icon", {
                                staticClass: "a_icon",
                                attrs: { type: "close" },
                                on: {
                                  click: function ($event) {
                                    _vm.closeData = false
                                  },
                                },
                              }),
                            ],
                            1
                          ),
                          _c("span", { staticClass: "r" }, [
                            _vm._v(
                              "附近100m内找到" +
                                _vm._s(_vm.companyNum) +
                                "家企业"
                            ),
                          ]),
                        ]),
                      ]),
                      _c(
                        "div",
                        { staticClass: "data_show" },
                        _vm._l(_vm.data.data, function (item, index) {
                          return _c(
                            "div",
                            { key: item.index, staticClass: "data_list" },
                            [
                              _c("div", { staticClass: "data_small_box" }, [
                                _c(
                                  "div",
                                  { staticClass: "change_logo_box" },
                                  [
                                    _c("a-checkbox", {
                                      on: {
                                        change: function ($event) {
                                          return _vm.onChange($event, index)
                                        },
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _c("div", { staticClass: "second_box" }, [
                                  _vm._v(" " + _vm._s(item.base) + " "),
                                ]),
                                _c(
                                  "div",
                                  {
                                    staticClass: "word_box",
                                    on: {
                                      click: function ($event) {
                                        return _vm.goDetail(item.name)
                                      },
                                    },
                                  },
                                  [
                                    _c("div", { staticClass: "word1_box" }, [
                                      _c(
                                        "div",
                                        { staticClass: "company_name" },
                                        [_vm._v(_vm._s(item.name))]
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "company_state" },
                                        [_vm._v(_vm._s(item.regStatus))]
                                      ),
                                    ]),
                                    _c("div", { staticClass: "word2_box" }, [
                                      _c(
                                        "div",
                                        { staticClass: "word_small_box" },
                                        [
                                          _vm._v(
                                            "法人：" +
                                              _vm._s(item.legalPersonName)
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "word_small_box word_small_box2",
                                          staticStyle: { width: "50%" },
                                        },
                                        [
                                          _vm._v(
                                            "所属行业：" + _vm._s(item.industry)
                                          ),
                                        ]
                                      ),
                                    ]),
                                    _c("div", { staticClass: "word3_box" }, [
                                      _c(
                                        "div",
                                        { staticClass: "word1_small_box" },
                                        [
                                          _vm._v(
                                            "成立日期：" +
                                              _vm._s(
                                                item.estiblishTime.split(" ")[0]
                                              )
                                          ),
                                        ]
                                      ),
                                      _c("div", { staticClass: "span_box" }, [
                                        _vm._v(
                                          "注册资本：" + _vm._s(item.regCapital)
                                        ),
                                      ]),
                                    ]),
                                  ]
                                ),
                                _c("div", {}, [
                                  _c(
                                    "button",
                                    {
                                      staticClass: "reset_box_again",
                                      on: {
                                        click: function ($event) {
                                          return _vm.nowGet(item)
                                        },
                                      },
                                    },
                                    [_vm._v("立即领取")]
                                  ),
                                  _c("br"),
                                  _c(
                                    "button",
                                    {
                                      staticClass: "blue_btn now_receive",
                                      staticStyle: { "margin-top": "12px" },
                                      attrs: { type: "primary" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.getInfo(item.name)
                                        },
                                      },
                                    },
                                    [_vm._v("地图标注")]
                                  ),
                                ]),
                              ]),
                            ]
                          )
                        }),
                        0
                      ),
                      _c(
                        "div",
                        { staticClass: "operate_method" },
                        [
                          _c(
                            "a-button",
                            {
                              staticStyle: { height: "100%" },
                              attrs: { type: "danger" },
                              on: { click: _vm.batchCollection },
                            },
                            [_vm._v(" 批量领取 ")]
                          ),
                        ],
                        1
                      ),
                    ])
                  : _vm._e(),
              ]),
              _c(
                "formModal",
                { attrs: { title: "企业详情", visible: _vm.editModalVisible } },
                [
                  _vm.editModalVisible
                    ? _c("detailForm", {
                        ref: "detailForm",
                        attrs: { rowId: _vm.id, companyName: _vm.companyName },
                        on: {
                          cancelled: function ($event) {
                            return _vm.closeEdit()
                          },
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }